import React from 'react';
import classnames from 'classnames';

import { useImageResize } from '../../../hooks/useImageResize';
import { QuoteAndTextFragment } from '../../../../graphql.schema';
import { VideoPlayer } from '../../VideoPlayer/VideoPlayer';
import Image from '../../Image';

import * as styles from './StrapiQuoteAndImage.module.scss';

export const StrapiQuoteAndImage = ({ image, quote, author, position, video }: QuoteAndTextFragment) => {
  const { imageWrapper, imageUrl } = useImageResize(image ?? { url: '' });
  
  return (
    <div ref={imageWrapper} className={classnames(styles.root)}>
      <div className={styles.media}>
        {/**
         * Video takes precedence over image. If both video and image are specified,
         * image will be used as the video thumbnail
         */}
        {video?.data ? (
          <VideoPlayer data-testid="wse-video-player" className={styles.video} video={video} poster={imageUrl} />
        ) : image ? (
          <Image data-testid="image" image={image} className={styles.image} loading="lazy" />
        ) : null}
        
      </div>
      <div className={styles.content}>
        <div className={styles.innercontent}>
        <h4 className={classnames('title is-4')}>{quote}</h4>
        <p className="is-text-3 black-2">{author}</p>
        <p className="is-text-3 black-2">{position}</p>
        </div>
      </div>
    </div>
  );
};
export default StrapiQuoteAndImage; 